import React from "react";
import MenuItem, { MiniMenuItem } from "../../common/sidebar/MenuItems";
import { ReactComponent as HomeIcon } from "../../../assets/icons/HomeIcon.svg";
import { ReactComponent as LogoutIcon } from "../../../assets/icons/LogoutIcon.svg";

const ACOMenu = ({ path, handleLogout }) => {
  return (
    <div className="container-fluid">
      <div style={{ height: "2vh" }} />
      <MenuItem
        href={"/aco/home"}
        text={"Home"}
        selected={path.includes("home")}
      >
        <HomeIcon />
      </MenuItem>
      <MiniMenuItem
        href={"/aco/members"}
        text={"Rose Care Team"}
        selected={path.includes("members")}
      ></MiniMenuItem>
      <MiniMenuItem
        href={"/aco/patient/total"}
        text={"Total Patients"}
        selected={path.includes("total")}
      ></MiniMenuItem>
      <MiniMenuItem
        href={"/aco/patient/active"}
        text={"Active Patients"}
        selected={path.includes("active")}
      ></MiniMenuItem>

      <div style={{ marginTop: "30%" }}>
        <hr style={{ color: "white", height: "2px", opacity: "100" }} />
        <MenuItem
          icon={LogoutIcon}
          onClick={handleLogout}
          href={""}
          text={"Logout"}
        >
          <LogoutIcon />
        </MenuItem>
      </div>
    </div>
  );
};

export default ACOMenu;
